// extracted by mini-css-extract-plugin
module.exports = {"About":"About_About__2neSa","Description":"About_Description__2Ua4s","Skills":"About_Skills__2lz9e"};